const ContactHero = () => {
  return (
    <section className="pt-32 pb-16 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <p className="text-xs uppercase tracking-widest text-gold mb-4 font-semibold">
          GET IN TOUCH
        </p>
        <h1 className="font-serif text-5xl lg:text-6xl font-bold text-navy-primary mb-8 max-w-4xl mx-auto leading-tight">
          Let's Discuss Your Practice Growth
        </h1>
        <p className="text-lg text-charcoal max-w-3xl mx-auto leading-relaxed mb-12">
          Connect with our team to explore how we can help optimize your
          clinical operations and drive sustainable growth.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-8 mb-8">
          <a
            href="tel:8665195999"
            className="flex items-center text-navy-primary hover:text-gold transition-colors duration-200 cursor-pointer"
          >
            <div className="w-12 h-12 flex items-center justify-center bg-gold/10 rounded-full mr-4">
              <i className="ri-phone-line text-2xl text-gold"></i>
            </div>
            <div className="text-left">
              <p className="text-xs uppercase tracking-wider text-charcoal mb-1">
                Call Us
              </p>
              <p className="text-lg font-semibold">(866) 519-5999</p>
            </div>
          </a>

          <a
            href="mailto:admin@irsventures.com"
            className="flex items-center text-navy-primary hover:text-gold transition-colors duration-200 cursor-pointer"
          >
            <div className="w-12 h-12 flex items-center justify-center bg-gold/10 rounded-full mr-4">
              <i className="ri-mail-line text-2xl text-gold"></i>
            </div>
            <div className="text-left">
              <p className="text-xs uppercase tracking-wider text-charcoal mb-1">
                Email Us
              </p>
              <p className="text-lg font-semibold">admin@irsventures.com</p>
            </div>
          </a>
        </div>

        <p className="text-sm text-charcoal">
          <i className="ri-map-pin-line text-gold mr-2"></i>
          Established in Kentucky
        </p>
      </div>
    </section>
  );
};

export default ContactHero;